// Auto-generated by npm run build:tokens — do not edit manually.
import type { Preset } from '@primeuix/themes/types';
import { ArrkPreset } from './arrk.preset';
import { MitsuiPreset } from './mitsui.preset';
export { Core } from './core.preset';
export { ArrkPreset, MitsuiPreset };

export const BRAND = {
  ARRK: 'ARRK',
  MITSUI: 'Mitsui'
} as const;

export type Brand = (typeof BRAND)[keyof typeof BRAND];

export const BRAND_PRESET_MAP: Record<Brand, Preset> = {
  [BRAND.ARRK]: ArrkPreset,
  [BRAND.MITSUI]: MitsuiPreset
};
